import { QueryClient } from '@tanstack/react-query';
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: true,
            retry: 3,
            retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000),
            staleTime: 5000,
            gcTime: 5 * 60 * 1000
        }
    }
});
export const queryKeys = {
    health: ['health']
};
